import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import { toast } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/Marquee";
import { Teamwork } from "@/components/Teamwork";
import { Benefits } from "@/components/Benefits";
import { OrderTicker } from "@/components/OrderTicker";
import { ZoneMap } from "@/components/ZoneMap";
import { Testimonials } from "@/components/Testimonials";
import { Recruitment } from "@/components/Recruitment";
import { Faq } from "@/components/Faq";
import { Footer } from "@/components/Footer";

export default function Landing() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.justSignedIn) {
      const u = location.state.user;
      toast.success(`Signed in as ${u?.name || u?.email} — you're on the Freshly list.`, { id: "google-auth" });
      window.history.replaceState({}, "");
    } else if (location.state?.authError) {
      toast.error("Google sign-in failed. Please try again.", { id: "google-auth" });
      window.history.replaceState({}, "");
    }
  }, [location.state]);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-bone font-manrope text-forest">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Teamwork />
        <Benefits />
        <OrderTicker />
        <ZoneMap />
        <Testimonials />
        <Recruitment />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}
